module.exports = __webpack_public_path__ + "static/media/2_17.6317236d.png";